import React from 'react';
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import ProductTypeForm from "./component/ProductTypeForm";

class ProductTypeFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de Tipos de Produto" to="/list/product-types"/>,
      <BreadcrumbItem key={3} title="Dados do Tipo de Produto" active={true}/>];
    return (
        <Page title="Dados do Tipo de Produto" breadcrumbs={breadcrumbs}>
          <ProductTypeForm match={match} history={history}/>
        </Page>
    );
  }
}

export default ProductTypeFormPage;



// WEBPACK FOOTER //
// ./src/productType/ProductTypeFormPage.js